import { toast } from "react-toastify";
import { auth } from "../firebase";
import { NavLink, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import {
  FaTachometerAlt,
  FaPoll,
  FaHistory,
  FaGift,
  FaUser,
  FaSignOutAlt,
} from "react-icons/fa";
import { useState } from "react";

function Navbar() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const confirmLogout = async () => {
    try {
      await signOut(auth);
      toast.success("You have been logged out successfully!");
      setShowModal(false);
      navigate("/login");
    } catch (error) {
      toast.error("Logout failed: " + error.message);
    }
  };

  return (
    <>
      <nav style={styles.navbar}>
        <div style={styles.container}>
          <div style={styles.logoWrapper}>
            <img
              src={require("../logo.png")}
              alt="Op4Insights Logo"
              style={styles.logo}
            />
          </div>
          <div style={styles.linkGroup}>
            <NavLink to="/dashboard" style={getLinkStyle}>
              <FaTachometerAlt style={styles.icon} />
              Dashboard
            </NavLink>
            <NavLink to="/surveys" style={getLinkStyle}>
              <FaPoll style={styles.icon} />
              Surveys
            </NavLink>
            <NavLink to="/history" style={getLinkStyle}>
              <FaHistory style={styles.icon} />
              History
            </NavLink>
            <NavLink to="/rewards" style={getLinkStyle}>
              <FaGift style={styles.icon} />
              Rewards
            </NavLink>
            <NavLink to="/profile" style={getLinkStyle}>
              <FaUser style={styles.icon} />
              Profile
            </NavLink>
            <a
              href="/logout"
              onClick={(e) => {
                e.preventDefault();
                setShowModal(true);
              }}
              style={{ ...styles.link, cursor: "pointer" }}
            >
              <FaSignOutAlt style={styles.icon} />
              Logout
            </a>
          </div>
        </div>
      </nav>

      {/* Logout Confirmation Modal */}
      {showModal && (
        <div style={modalStyles.overlay}>
          <div style={modalStyles.modal}>
            <h3 style={modalStyles.title}>Confirm Logout</h3>
            <p style={modalStyles.text}>
              Are you sure you want to log out?
            </p>
            <div style={modalStyles.buttons}>
              <button
                onClick={() => setShowModal(false)}
                style={modalStyles.cancel}
              >
                Cancel
              </button>
              <button
                onClick={confirmLogout}
                style={modalStyles.confirm}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;

// Active link styling function
const getLinkStyle = ({ isActive }) => ({
  ...styles.link,
  color: isActive ? "#8F27FF" : "#555",
  borderBottom: isActive ? "2px solid #8F27FF" : "2px solid transparent",
});

const styles = {
  navbar: {
    backgroundColor: "#fff",
    borderBottom: "1px solid #eee",
    // padding: "10px 40px",
    position: "sticky",
    top: 0,
    zIndex: 999,
    boxShadow: "0 2px 5px rgba(0,0,0,0.04)",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  logoWrapper: {
    flexShrink: 0,
  },
  logo: {
    height: 85,
    width: 150,
    paddingTop: 10,
  },
  linkGroup: {
    display: "flex",
    gap: 28,
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
  },
  link: {
    fontSize: 15,
    fontWeight: 500,
    textDecoration: "none",
    color: "#555",
    paddingBottom: 4,
    transition: "all 0.3s ease",
    borderBottom: "2px solid transparent",
    display: "flex",
    alignItems: "center",
  },
  icon: {
    marginRight: 6,
    fontSize: 15,
  },
};

const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "30px 40px",
    borderRadius: "12px",
    maxWidth: 400,
    width: "100%",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    animation: "fadeIn 0.3s ease-in-out",
  },
  title: {
    marginBottom: 10,
    fontSize: 22,
    fontWeight: 700,
    color: "#15007d",
    textAlign: "center",
  },
  text: {
    fontSize: 16,
    color: "#444",
    textAlign: "center",
    marginBottom: 20,
  },
  buttons: {
    display: "flex",
    justifyContent: "space-between",
    gap: 16,
  },
  cancel: {
    flex: 1,
    backgroundColor: "#eee",
    border: "none",
    borderRadius: 6,
    padding: "10px 16px",
    fontSize: 14,
    cursor: "pointer",
    fontWeight: 500,
  },
  confirm: {
    flex: 1,
    backgroundColor: "#8F27FF",
    border: "none",
    borderRadius: 6,
    padding: "10px 16px",
    color: "#fff",
    fontSize: 14,
    cursor: "pointer",
    fontWeight: 500,
  },
};
